/**
 * Do not edit directly
 * Generated on Mon, 29 Sep 2025 10:23:30 GMT
 */

export const ColorPrimary01 = "#ffa6b6";
export const ColorPrimary02 = "#0054c8";
export const ColorPrimary03 = "#ffffff";
export const ColorPrimaryMembership = "#00204d";
export const ColorTextHeadline = "#00204d";
export const ColorTextBody = "#313131";
export const ColorTextLabel = "#00204d";
export const ColorTextAlternate = "#00204d";
export const ColorTextInverted = "#ffffff";
export const ColorTextPlaceholder = "#767676";
export const ColorInteractionButton = "#0054c8";
export const ColorInteractionButtonHover = "#004099";
export const ColorInteractionButtonFocus = "#0459d9";
export const ColorInteractionTextLink = "#0054c8";
export const ColorInteractionTextLinkHover = "#004099";
export const ColorInteractionTextLinkFocus = "#0459d9";
export const ColorInteractionIcon = "#00204d";
export const ColorInteractionIconHover = "#ce3356";
export const ColorInteractionSelectedState = "#0054c8";
export const ColorInteractionSelectedStateHover = "#004099";
export const ColorInteractionFocusIndicator = "#0054c8";
export const ColorInteractionDeactivated = "#a3a3a3";
export const ColorInteractionControl = "#767676";
export const ColorInteractionControlHoverFill = "#f0f1f3";
export const ColorInteractionLoading = "#767676";
export const ColorInteractionHoverState = "#d34767";
export const ColorInteractionIconFavourite = "#ce3356";
export const ColorInteractionFocusState = "#b92e4d";
export const ColorInteractionDefault = "#c22f50";
export const ColorInteractionBackgroundHover = "#e6eefa";
export const ColorFeedbackError = "#eb1000";
export const ColorFeedbackInformation = "#0054c8";
export const ColorFeedbackSuccess = "#2e691f";
export const ColorFeedbackWarning = "#fc640d";
export const ColorFeedbackRating = "#f9c406";
export const ColorBackground01 = "#ffffff";
export const ColorBackground02 = "#f0f1f3";
export const ColorBackground03 = "#e6eefa";
export const ColorBackground04 = "#e6e9ed";
export const ColorBackground05 = "#ffd3db";
export const ColorBackground06 = "#fff8f9";
export const ColorBackground07 = "#00204d";
export const ColorBackgroundError = "#fde7e5";
export const ColorBackgroundWarning = "#ffefe7";
export const ColorBackgroundInformation = "#dbeaff";
export const ColorBackgroundSuccess = "#e6f1e9";
export const ColorBackgroundSite = "#f8f8f9";
export const ColorBackgroundBranded = "#ffa6b6";
export const ColorBackgroundSelectedState = "#e6eefa";
export const ColorBackgroundHero = "#ffd3db";
export const ColorBackgroundDeactivated = "#e8e8e8";
export const ColorBackgroundHoverState = "#fff8f9";
export const ColorBorder01 = "#767676";
export const ColorBorder02 = "#8d8d8d";
export const ColorBorder03 = "#e8e8e8";
export const ColorBorder04 = "#f4f4f4";
export const ColorPillSponsored = "#d1d1d1";
export const ColorPillMembership = "#00204d";
export const ColorPillUsp = "#f9c406";
export const ColorPillPrice = "#eb1000";
export const ColorPillMarketing = "#0054c8";
export const ColorPillEco = "#2e691f";
export const ColorBlack10 = "#e8e8e8";
export const ColorBlack20 = "#d1d1d1";
export const ColorBlack30 = "#bababa";
export const ColorBlack40 = "#a3a3a3";
export const ColorBlack50 = "#8d8d8d";
export const ColorBlack60 = "#767676";
export const ColorBlack70 = "#5f5f5f";
export const ColorBlack80 = "#484848";
export const ColorBlack90 = "#313131";
export const ColorBlack100 = "#1a1a1a";
export const ColorBlack00 = "#ffffff";
export const ColorBlack05 = "#f4f4f4";
export const Spacing10 = 32;
export const Spacing11 = 40;
export const Spacing12 = 48;
export const Spacing13 = 64;
export const Spacing14 = 80;
export const Spacing15 = 96;
export const Spacing16 = 160;
export const SpacingNone = 0;
export const Spacing01 = 1;
export const Spacing02 = 2;
export const Spacing03 = 4;
export const Spacing04 = 8;
export const Spacing05 = 12;
export const Spacing06 = 16;
export const Spacing07 = 20;
export const Spacing08 = 24;
export const Spacing09 = 28;
export const BorderRadius00 = "0px";
export const BorderRadius01 = "4px";
export const BorderRadius02 = "8px";
export const BorderRadius03 = "12px";
export const BorderRadius04 = "16px";
export const BorderRadius05 = "20px";
export const BorderRadius06 = "24px";
export const BorderRadiusCircle = "50%";
export const BorderRadiusSelector = "8px";
export const BorderRadiusChip = "50%";
export const BorderWidth00 = "0px";
export const BorderWidth01 = "1px";
export const BorderWidth02 = "2px";
export const BorderWidth03 = "3px";
export const BorderWidth04 = "4px";
export const BorderWidth05 = "5px";
export const BorderWidth06 = "6px";
export const BorderWidthSelectorDefault = "2px";
export const BorderWidthSelectorHover = "3px";
export const BorderWidthSelectorSelected = "4px";
export const FontFamilyFallback = "Arial, Sans-Serif";
export const FontFamilyPrimary = "Moonpig";
export const FontFamilyStack = "Moonpig, Arial, Sans-Serif";
export const FontWeight300 = 300;
export const FontWeight500 = 500;
export const FontWeight700 = 700;
export const FontSize01 = "0.875rem";
export const FontSize02 = "1rem";
export const FontSize03 = "1.125rem";
export const FontSize04 = "1.25rem";
export const FontSize05 = "1.5rem";
export const FontSize06 = "1.75rem";
export const FontSize07 = "2rem";
export const FontSize08 = "2.5rem";
export const BoxShadow00 = "0px 0px 0px 0px #000000";
export const BoxShadow01 = "0px 1px 4px 0px #00204d26";
export const BoxShadow02 = "0px 3px 8px 0px #00034d26";
export const BoxShadow03 = "0px 6px 12px 0px #00204d26";
export const BoxShadow04 = "0px 8px 18px 0px #00204d26";
export const BoxShadow05 = "0px 0px 0px 2px #FFFFFF, 0px 0px 0px 5px #0054C8";
export const BoxShadowFocus = "0px 0px 0px 2px #FFFFFF, 0px 0px 0px 5px #0054C8";
export const LineHeight01 = "1.375rem";
export const LineHeight02 = "1.5rem";
export const LineHeight03 = "1.625rem";
export const LineHeight04 = "1.75rem";
export const LineHeight05 = "2rem";
export const LineHeight06 = "2.25rem";
export const LineHeight07 = "2.5rem";
export const LineHeight08 = "3rem";
export const TextDecorationNone = "none";
export const TextDecorationUnderline = "underline";
export const SizeIconSmall = "1rem";
export const SizeIconMedium = "1.5rem";
export const SizeIconLarge = "2rem";
export const SizeTouchSquare = "3rem";
export const TypeDesktopDisplay01 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"3rem","fontSize":"2.5rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopDisplay02 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"2.5rem","fontSize":"2rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopDisplay03 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"2.25rem","fontSize":"1.75rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopDisplay04 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"2rem","fontSize":"1.5rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopDisplay05 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.75rem","fontSize":"1.25rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopDisplay06 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.625rem","fontSize":"1.125rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopBodyLabel = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopBodyLead = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.625rem","fontSize":"1.125rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopBodyText = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopBodyCaption = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.375rem","fontSize":"0.875rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopButtonLabel = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeDesktopButtonUnderlined = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"underline","textCase":0};
export const TypeDesktopButtonTextLink = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"underline","textCase":0};
export const TypeMobileDisplay01 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"2.25rem","fontSize":"1.75rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileDisplay02 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"2rem","fontSize":"1.5rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileDisplay03 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.75rem","fontSize":"1.25rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileDisplay04 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.625rem","fontSize":"1.125rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileDisplay05 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileDisplay06 = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.375rem","fontSize":"0.875rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileBodyLabel = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileBodyLead = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.625rem","fontSize":"1.125rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileBodyText = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileBodyCaption = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.375rem","fontSize":"0.875rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileButtonLabel = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"none"};
export const TypeMobileButtonUnderlined = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":700,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"underline","textCase":0};
export const TypeMobileButtonTextLink = {"fontFamily":"Moonpig, Arial, Sans-Serif","fontWeight":300,"lineHeight":"1.5rem","fontSize":"1rem","letterSpacing":0,"paragraphSpacing":0,"textDecoration":"underline","textCase":0};
export const BooleanIsMoonpig = "[object Object]";
export const BooleanIsGreetz = "[object Object]";
export const ZIndexBehind = -1;
export const ZIndexDefault = 0;
export const ZIndexElements = 10;
export const ZIndexDropdown = 100;
export const ZIndexSticky = 200;
export const ZIndexOverlay = 500;
export const ZIndexModal = 1000;
